// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".19d120815562c697abec7b94bf84be9c9e06e12a.chunk.js";
};